import React from 'react';
import { Controller } from 'react-hook-form';

import { MezzaFormField, MezzaFormFieldProps } from '../MezzaForm';
import { inputLabels } from '../../../data/labels';
import Input from '../../Input/Input';

const Door = ({ control }: MezzaFormFieldProps) => {
  return (
    <Controller
      control={control}
      name={MezzaFormField.DOOR}
      render={({ field }) => (
        <Input
          id={MezzaFormField.DOOR}
          value={field.value}
          setValue={field.onChange}
          label={inputLabels.door}
        />
      )}
    />
  );
};

export default React.memo(Door);
